import Icon from "./common/icon";
const Tasks = ({ task, edit, remove }) => {

    return (
        <>

            <li className="container flex mb-4 flex-col justify-center items-center" id={task.id}>
                <h1 className="font-bold text-md">{task.task}</h1>
                <div className="container flex m-3 justify-between">
                    <Icon iconName={'FaPen'} styles={'text-gray-400 cursor-pointer text-2xl mx-3 hover:text-gray-300'} click={() => { edit(task.id) }} />
                    <Icon iconName={'FaTrash'} styles={'text-dangerColor cursor-pointer  text-2xl mx-3 hover:text-red-600'} click={() => { remove(task.id) }} />
                </div>
            </li>
        </>);
}

export default Tasks;